/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit': {
    width: 11,
    height: 11,
    viewBox: '0 0 11 11',
    data: '<g _stroke="#376F99" _fill="none" fill-rule="evenodd"><path pid="0" d="M10.41 2.41a.271.271 0 0 0 0-.382L9.042.662a.27.27 0 0 0-.382 0l-5.089 5.09c-.063.062-.95 2.297-.983 2.38a.27.27 0 0 0 .35.351c.08-.032 2.321-.924 2.38-.985l5.09-5.089zM3.835 5.446l1.747 1.747"/><path pid="1" d="M2.75 7.731l.591.591" stroke-width=".5"/><path pid="2" d="M8.458 6.594v2.85c0 .369-.112.626-.48.626H1.583a.598.598 0 0 1-.625-.625V3.094c0-.39.278-.524.669-.524h2.858"/></g>'
  }
})
